export const pageUtils =[
    {
        id: 1,
        name: "Sobre Nosotros",
        text:"",
        link:"/about"
    },
        {
        id: 2,
        name: "Servicios",
        text:"",
        link:"/services"
    },
        {
        id: 1,
        name: "Clientes",
        text:"",
        link:"/clients"
    },
        {
        id: 1,
        name: "Contacto",
        text:"",
        link:"/contact"
    },
]